<template>
  <v-layout row wrap>
    <v-flex xs12 v-show="!player_id">
      <v-card>
        <v-card-text>
          <v-subheader class="pa-0">Qui es-tu ?</v-subheader>
          <v-autocomplete
            @change="$emit('select-player', playerId)"
            v-model="playerId"
            :items="players"
            :label="`Joueur`"
            item-text="name"
            item-value="id"
          >
          </v-autocomplete>
        </v-card-text>
      </v-card>
    </v-flex>

    <v-flex xs12 sm6 md3 lg3 xl3 v-show="player_id">
      <HomeRecommendation image="https://images.unsplash.com/photo-1528302137539-73565e0ab964?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1351&q=80"
                          title="Nos recommandations"
                          description="Pas d'idées ? Relèves de nouveaux défis en allant dans les recommandations personnalisées !"
                          @click="$emit('go-to-my-recommendations')"></HomeRecommendation>
    </v-flex>

    <v-flex xs12 sm6 md3 lg3 xl3 v-show="player_id">
      <HomeRecommendation image="https://images.unsplash.com/photo-1534488972407-5a4aa1e47d83?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2018&q=80"
                          title="Ta Kill List"
                          description="Tu veux savoir qui est juste au dessus de toi dans les classements ?"
                          @click="$emit('go-to-kill-list')"></HomeRecommendation>
    </v-flex>

    <v-flex xs12 sm6 md3 lg3 xl3 v-show="player_id">
      <HomeRecommendation image="https://images.unsplash.com/photo-1533237264985-ee62f6d342bb?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80"
                          title="Tes scores"
                          description="Envie de voir tous tes scores que tu as réalisés ?"
                          @click="$emit('go-to-history')"></HomeRecommendation>
    </v-flex>

    <v-flex xs12 sm6 md3 lg3 xl3 v-show="player_id">
      <HomeRecommendation image="https://images.unsplash.com/photo-1550745165-9bc0b252726f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80"
                          title="Tes plateformes"
                          description="Envie de voir toutes les plateformes sur lesquelles tu as scorées ?"
                          @click="$emit('go-to-my-platforms')"></HomeRecommendation>
    </v-flex>

    <v-flex xs12 sm6 md3 lg3 xl3 v-show="player_id">
      <HomeRecommendation image="https://images.unsplash.com/photo-1543622748-5ee7237e8565?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1350&q=80"
                          title="Tes jeux"
                          description="Envie de voir tous les jeux sur lesquels tu as scorés ?"
                          @click="$emit('go-to-my-games')"></HomeRecommendation>
    </v-flex>

  </v-layout>
</template>

<script>
  import HomeRecommendation from '@/components/atoms/HomeRecommendation';
  export default {
    components: { HomeRecommendation },
    props: ['players', 'player_id'],
    data: () => {
      return {
        playerId: null,
      };
    },
  };
</script>
